<app-topheader></app-topheader>
<div class="scrollingcontainer ">

    <div class="container">
        <app-fancy-page-title *ngIf="pagemask==false" topTitle="PLANNED CRUISE ITINERARY"></app-fancy-page-title>
        <app-fancy-page-title *ngIf="pagemask==true" topTitle="PLANNED ITINERARY"></app-fancy-page-title>


        <!-- <app-goldbar></app-goldbar>
        <app-current-date></app-current-date> -->
        <div class="tenpxtop"></div>
        <app-longgoldbar></app-longgoldbar>

        <!-- <app-pci></app-pci> -->
        <app-pcidata></app-pcidata>
        <div class="tenpxtop"></div>
        <div class="disclaimer">Please note that arrival and departure times as well as ports of call and land
            experiences are subject to change.
            American Cruise Lines makes every effort to maintain our schedule, however, circumstances such as weather,
            channel
            conditions, availability of docks, operation of locks, "animal traffic jams" in National Parks, or any other
            reason may
            cause a change to this itinerary. This is the nature of small ship cruising and curated land packages and we
            appreciate
            your patience. We encourage you to revisit this page often and before traveling to the ship for the most
            up-to-date
            information.</div>
        <div class="tenpxtop"></div>
    </div>
</div>
<app-bottommenu></app-bottommenu>